import React from "react";
import codeImage from "../assets/doge.jpg";
import PageSection from "./PageSection";


const DevApi = () => {
  return (
    <PageSection
      name="about"
      title="About"
      subtitle={`SWF Lab was born in Jun. 2022 at NTU(National Taiwan University, Taipei, Taiwan), we research everything about Blockchain.`}
    >
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
        {/* left */}

        <div className="flex flex-col gap-4 w-full lg:w-1/2 p-8 bg-gray-200 rounded-lg">
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Social</b> <br />DAOs, Marketing, Liberal Radicalism & Radical Market
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Witness</b> <br/>Zero Knowledge Proof
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Finance</b> <br />DeFi & NFTs, Stocks/Currency Research
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Blockchain</b> <br />Underlying Architecture, Layer 2, Side-Chain, Cross-Chain
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Dev. & Theory</b> <br />Blockchain / Smart Contract / Dapps, Full-Stack, Other Theory
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>Data & Reality</b> <br />Data Science / Analysis, Augmented / Virtual Reality
          </p>
          <p className="border-l-4 pl-4 odd:border-thOrange even:border-thBlue">
            <b>swfProducts</b> <br/>Products Introduction / Announcements, Future Plans
          </p>
        </div>
        {/* right */}
        <div className="w-full lg:w-2/5 lg:rotate-6 duration-300 hover:rotate-0">
          <img
            src={codeImage}
            alt="code"
            className="rounded-lg shadow-lg shadow-thBlue"
          />
        </div>
      </div>
    </PageSection>
  );
};

export default DevApi;
